// Everything any part of the site keeps in browser storage for a signed-in
// user. The site has one sign-out (home's /logout), so it must clear what every
// practice area stores, not only what home itself writes.

const SIGNED_IN_LOCAL_KEYS = new Set([
  // Credentials (current names plus legacy ones some areas still read).
  'access',
  'access_expiration',
  'refresh',
  'refresh_expiration',
  'user',
  'isAuthenticated',
  'chat_token',
  'chatToken',
  'access_token',
  'token',
  'juristai_token',
  // Matter, workspace and flow state.
  'prosecutorial_response',
  'case_id',
  'thread_id',
  'documentNeed',
  'supportInput',
  'caseflow:stage',
  'caseFlowLastModal',
  'caseflow:visitedSteps',
  'federalPath',
  'lawsuitRecommendation',
  'litigaiJourneyDescription',
  'courtId',
  'lastPaymentSession',
  'atticusPendingCaseCheckout',
  'litigai.conversationCorrelations',
  'templateUploadHistory:v1',
  'legalTeamInvite',
  'juristai.litigai.chat.unread.v1',
  'seriesai:workspace',
  'inhouse:workspace',
  'seriesai-onboarding-v2',
]);

const SIGNED_IN_LOCAL_PREFIXES = [
  'caseSummary_',
  'caseSummaryS3Key_',
  'motionTypes_',
  'motionTypesFetched_',
  'recommendationMotions_',
  'case_party_',
  'caseActionItemAssignees_',
  'litigai-task-workspace-v1:',
  'legalTeamsCache:',
  'engagement-letter-firm-profile:',
  'atticus-upload-documents-',
  'atticus-upload-documents:',
  'google_oauth_ctx_',
  'msft_oauth_ctx_',
  'yahoo_oauth_ctx_',
  'seriesai:workspace-seed:v1:',
];

export const isSignedInStateKey = (key) =>
  SIGNED_IN_LOCAL_KEYS.has(key) ||
  SIGNED_IN_LOCAL_PREFIXES.some((prefix) => key.startsWith(prefix));

export const clearSignedInState = ({ extraKeys = [] } = {}) => {
  try {
    const extra = new Set(extraKeys);
    Object.keys(localStorage).forEach((key) => {
      if (extra.has(key) || isSignedInStateKey(key)) localStorage.removeItem(key);
    });
  } catch (error) {
    // Storage can throw (private mode, blocked site data); sign-out still proceeds.
    console.warn('Unable to clear signed-in local state:', error);
  }
  try {
    // Session storage holds per-case, interview and OAuth values that cannot be
    // enumerated safely.
    sessionStorage.clear();
  } catch (error) {
    console.warn('Unable to clear signed-in session state:', error);
  }
};
